import Divider from 'components/Divider/Divider';

export default Divider;
